import { createGlobalStyle } from "styled-components";

export const ResetStyle = createGlobalStyle`
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
address, caption, cite, code, dfn, em, strong, th, var, b {
  font-weight: normal;
  font-style: normal;
}
abbr, acronym {
  border: 0;
}
article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
  display: block;
}
*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}
html {
  text-size-adjust: 100%;
  box-sizing: border-box;
}
body {
    line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote {
  &:before,   &:after {
    content: '';
    content: none;
  }
}
q {
  &:before,   &:after {
    content: '';
    content: none;
  }
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
caption, th {
  text-align: left;
}
textarea {
  resize: none;
}
a {
  text-decoration: none;
  cursor: pointer;
}
button {
  padding: 0;
  border: none;
  background: none;
}
/* 滾動條樣式 */
::-webkit-scrollbar-track-piece {
  background-color: #f8f8f8;
}
::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;

}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
  border-radius: 10px;
}

`;

// *default font-size equal 1 rem*/
export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size:14px;
    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji'; */
  }
  /* 特殊修改 */
  .pdt-rate-text span{
    margin-left: 0px !important;
    padding-left: 0px !important;
  }
  /* 空select 文字顏色 */
  .ant-empty-description{
    color: #C4C4C4  !important;
  }

  .ant-divider-horizontal{
    margin: 12px 0 !important;
  }  
  
  .ant-message {
    font-weight: 600;
    font-size:23px !important;
    color: #595959 !important;
  }

  .ant-btn{
    border-radius: 5px !important;
  }

  .ant-checkbox-group-item{
    font-size: 21px !important;
  }

  .ant-typography{
    font-weight: 400 !important;
  }

  .flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flex-start{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .flex-end{
    display: flex;
    justify-content: end;
    align-items: center;
  }
  .flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex-col-center{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .flex-col-end{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }
  .flex-wrap{
    flex-wrap:wrap;
  }
  .flex-inline{
    display:inline-flex;
  }
  .flex-1 {
    flex: 1;
  }

  .flex {
    display: flex;
  }

  .flex-row {
    flex-direction: row;
  }
  .flex-col {
    flex-direction: column;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-around {
    justify-content: space-around;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .items-start {
    align-items: start;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: end;
  }

  .gap-5px{
    gap: 5px;
  }

  /* --------------------------------------------- */

  .font-size-24{
    font-size: 24px;
  }

  .w-100{
    width:100% ;
  }
  .w-80{
    width:80% ;
  }
  .w-50{
    width:50% ;
  }
  // ------------------------------
  .h-100{
    height:100% ;
  }
  .h-80{
    height:80% ;
  }
  .h-50{
    height:50% ;
  }
  .mt-10{
    margin-top: 10px;
  }
  .mt-20{
    margin-top: 20px;
  }
  .mt-30{
    margin-top: 30px;
  }
  .mt-35{
    margin-top: 35px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }
  
  .align-l{
    text-align: left;
  }
  .align-r{
    text-align: right;
  }

  // ------------------------------

  .pl-5{
    padding-left: 5px;
  }
  .pr-5{
    padding-right: 5px;
  }
  .pr-16{
    padding-right:16px;
  }
  .pl-16{
    padding-left: 16px;
  }
  .pt-16{
    padding-top: 16px;
  };
  .p-15px {
    padding: 15px;
  };

  // ------------------------------

  .mr-15px {
    margin-right: 15px;
  }

  // ------------------------------
  .mt-15px {
    margin-top: 15px;
  }
`;
